import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserDetailsResponse } from '../interfaces/responses/models';
import { UserUpdateRequest } from '../interfaces/requests/models';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private createUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  getAllUser(): Observable<any> {
    return this.http.get<any>(this.createUrl('users/'));
  }

  addUserToGroup(data: any): Observable<any> {
    return this.http.put<any>(this.createUrl('groups/role'), data);
  }

  deleteUser(user_id: string): Observable<any> {
    return this.http.delete<any>(this.createUrl(`users/${user_id}`));
  }

  getCurrentUserDetails(): Observable<UserDetailsResponse> {
    return this.http.get<UserDetailsResponse>(this.createUrl('users/current'));
  }

  getUserName(customerId: number): Observable<any> {
    return this.http.get<any>(this.createUrl(`users/${customerId}`));
  }

  updateUser(userId: string, data: UserUpdateRequest): Observable<any> {
    return this.http.put<any>(this.createUrl(`users/${userId}`), data);
  }

  getUserCountByType(): Observable<any> {
    return this.http.get<any>(this.createUrl(`users/count`));
  }

  getTotalInstalledCapacity(): Observable<any> {
    return this.http.get<any>(this.createUrl(`users/solar/installed`));
  }

  getUserUtilityConfiguration(): Observable<any> {
    return this.http.get<any>(this.createUrl(`users/utility/configuration`));
  }

  /**
   * Helper to process dashboard counts from the UserType array.
   */
  processDashboardCounts(data: any[]): { users_count: number; utility_count: number } {
    let users_count = 0;
    let utility_count = 0;
    
    data.forEach(item => {
      users_count += (item.total || 0);
      if (item.type === 'Utility') {
        utility_count += (item.total || 0);
      }
    });

    return { users_count, utility_count };
  }
}
